package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.supplier.ui.ChangeSupplierPopup
import com.essntl.features.supplier.ui.SupplierItem
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.input.label.EsInputLabel
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing

@Composable
fun ServiceSupplierInformation(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
    enabled: Boolean,
) {
    var isChangeSupplierPopupOpen by rememberSaveable { mutableStateOf(false) }

    Spacer(modifier = Modifier.height(2.spacing))

    EsInputLabel(
        label = "Suppliers",
    )

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.fillMaxWidth(),
    ) {
        if (state.getAllSuppliersService.isLoading)
            EsSpinner()
        else
            state.getAllSuppliersService.data.orEmpty().forEachIndexed { index, supplier ->
                SupplierItem(
                    supplierService = supplier,
                    enabled = enabled,
                    onDeleteSupplier = { onEvent(AddEditServiceEvent.RemoveSupplier(supplier)) },
                    modifier = Modifier.fillMaxWidth(),
                )

                if (index != state.getAllSuppliersService.data.orEmpty().lastIndex)
                    Spacer(modifier = Modifier.height(1.spacing))
            }

        Spacer(modifier = Modifier.height(1.spacing))

        EsLargeSecondaryButton(
            onClick = {
                isChangeSupplierPopupOpen = true
            },
            text = "Add supplier",
            suffixIconRes = EsIcons.Add,
            enabled = enabled,
            modifier = Modifier.fillMaxWidth(),
        )

        Spacer(modifier = Modifier.height(3.spacing))
    }

    ChangeSupplierPopup(
        state = contactState,
        onEvent = contactEvent,
        title = "Add supplier",
        buttonText = "Add",
        isOpen = isChangeSupplierPopupOpen,
        onSelectSupplier = { supplier ->
            onEvent(AddEditServiceEvent.AddSupplier(supplier))
        },
        onDismissRequest = {
            isChangeSupplierPopupOpen = false
        },
    )
}